import { render, staticRenderFns } from "./share-link.vue?vue&type=template&id=816750e2"
import script from "./share-link.vue?vue&type=script&lang=js"
export * from "./share-link.vue?vue&type=script&lang=js"
import style0 from "./share-link.vue?vue&type=style&index=0&id=816750e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports